import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'

// store
import Auth from './Auth'
import Socket from './Socket'
import AlertModal from './AlertModal'
import Me from './Me'
import Profile from './Profile'
import Account from './Account'
import AccountSettings from './accountSettings'
import AccountDomains from './accountDomains'
import AccountSSO from './accountSSO'
import AccountCareersite from './accountCareersite'
import AccountApplyfields from './accountApplyfields'
import AccountSocial from './accountSocial'
import AccountConversationalAgent from './accountConversationalAgent'
import AccountResourceAvailability from './accountResourceAvailability'
import Integrations from './integrations'
import Connections from './connections'
import MessagingChannels from './messagingChannels'
import MessagingConversations from './messagingConversations'
import MessagingMessages from './messagingMessages'

import Notification from './Notification'
import CalendarEvent from './CalendarEvent'
import Job from './Job'
import JobLog from './JobLog'
import JobScoreform from './JobScoreform'
import JobAttach from './JobAttach'
import Candidate from './Candidate'
import CandidateBoard from './CandidateBoard'
import CandidateController from './CandidateController'
import CandidateSelected from './CandidateSelected'
import CandidateAttach from './CandidateAttach'
import Resource from './Resource'
import Placement from './Placement'
import Tag from './Tag'
import CustomFieldGroup from './CustomFieldGroup'
import Role from './Role'
import Session from './Session'
import Templatemail from './Templatemail'
import Templateapply from './Templateapply'
import Stage from './Stage'
import Dexport from './Dexport'
import Dataimex from './Dataimex'
import Activity from './Activity'
import Company from './Company'
import Audit from './Audit'
import Departament from './Departament'
import Scoreform from './Scoreform'
import Videoform from './Videoform'
import Questionform from './Questionform'
import Approvalrule from './Approvalrule'
import Consumption from './Consumption'
import Source from './Source'
import Careerpage from './Careerpage'
import Careersite from './Careersite'
import Member from './Member'
import MemberInvite from './MemberInvite'
import DisqualifyReason from './DisqualifyReason'
import CancelReason from './CancelReason'
import Contract from './Contract'
import Media from './Media'
import Event from './Event'
import Note from './Note'
import Meetinsight from './Meetinsight'
import Meetcontext from './Meetcontext'
import Gdprlog from './Gdprlog'
import ShareCandidate from './ShareCandidate'
import QuestionnaireInvite from './QuestionnaireInvite'
import Questionnaire from './Questionnaire'
import IntervideoInvite from './IntervideoInvite'
import Intervideo from './Intervideo'
import IntervideoRating from './IntervideoRating'
import IntervoiceInvite from './IntervoiceInvite'
import Intervoice from './Intervoice'
import CandidateDuplicates from './CandidateDuplicates'
import JobBoard from './JobBoard'
import Posting from './Posting'
import Email from './Email'
import Evaluation from './Evaluation'
import Task from './Task'
import Approvalflow from './Approvalflow'
import Requisition from './Requisition'
import Approval from './Approval'
import Dashboard from './Dashboard'
import Dashcomponent from './Dashcomponent'
import Warn from './Warn'
import MeetMain from './MeetMain'
import Modalo from './Modalo'
import ReportingFilters from './ReportingFilters'
import Billing from './Billing'
import CreateBilling from './CreateBilling'
import Menu from './Menu'

// models
import NotificationModel from '../models/Notification'
import CalendarEventModel from '../models/CalendarEvent'
import AccountModel from '../models/Account'
import TagModel from '../models/Tag'
import CustomFieldGroupModel from '../models/CustomFieldGroup'
import RoleModel from '../models/Role'
import SessionModel from '../models/Session'
import TemplatemailModel from '../models/Templatemail'
import TemplateapplyModel from '../models/Templateapply'
import JobModel from '../models/Job'
import JobLogModel from '../models/JobLog'
import JobAttachModel from '../models/JobAttach'
import CandidateModel from '../models/Candidate'
import CandidateAttachModel from '../models/CandidateAttach'
import PlacementModel from '../models/Placement'
import StageModel from '../models/Stage'
import DexportModel from '../models/Dexport'
import DataimexModel from '../models/Dataimex'
import ActivityModel from '../models/Activity'
import CompanyModel from '../models/Company'
import AuditModel from '../models/Audit'
import DepartamentModel from '../models/Departament'
import ScoreformModel from '../models/Scoreform'
import VideoformModel from '../models/Videoform'
import QuestionformModel from '../models/Questionform'
import ApprovalruleModel from '../models/Approvalrule'
import ConsumptionModel from '../models/Consumption'
import SourceModel from '../models/Source'
import CareerpageModel from '../models/Careerpage'
import CareersiteModel from '../models/Careersite'
import MemberModel from '../models/Member'
import MemberInviteModel from '../models/MemberInvite'
import DisqualifyReasonModel from '../models/DisqualifyReason'
import CancelReasonModel from '../models/CancelReason'
import ContractModel from '../models/Contract'
import EventModel from '../models/Event'
import NoteModel from '../models/Note'
import MeetinsightModel from '../models/Meetinsight'
import GdprlogModel from '../models/Gdprlog'
import ShareCandidateModel from '../models/ShareCandidate'
import QuestionnaireInviteModel from '../models/QuestionnaireInvite'
import QuestionnaireModel from '../models/Questionnaire'
import IntervideoInviteModel from '../models/IntervideoInvite'
import IntervideoModel from '../models/Intervideo'
import IntervideoRatingModel from '../models/IntervideoRating'
import IntervoiceInviteModel from '../models/IntervoiceInvite'
import IntervoiceModel from '../models/Intervoice'
import JobBoardModel from '../models/JobBoard'
import PostingModel from '../models/Posting'
import EmailModel from '../models/Email'
import EvaluationModel from '../models/Evaluation'
import TaskModel from '../models/Task'
import ApprovalflowModel from '../models/Approvalflow'
import RequisitionModel from '../models/Requisition'
import ApprovalModel from '../models/Approval'
import DashboardModel from '../models/Dashboard'
import DashcomponentModel from '../models/Dashcomponent'
import ConnectionModel from '../models/Connection'
import ConversationModel from '../models/Conversation'
import MessageModel from '../models/Message'

Vue.use(Vuex)

// Create a new database instance.
const database = new VuexORM.Database()

database.register(NotificationModel, {})
database.register(CalendarEventModel, {})
database.register(AccountModel, {})
database.register(TagModel, {})
database.register(CustomFieldGroupModel, {})
database.register(RoleModel, {})
database.register(SessionModel, {})
database.register(TemplatemailModel, {})
database.register(TemplateapplyModel, {})
database.register(JobModel, {})
database.register(JobLogModel, {})
database.register(JobAttachModel, {})
database.register(CandidateModel, {})
database.register(CandidateAttachModel, {})
database.register(PlacementModel, {})
database.register(DisqualifyReasonModel, {})
database.register(StageModel, {})
database.register(DexportModel, {})
database.register(DataimexModel, {})
database.register(ActivityModel, {})
database.register(CompanyModel, {})
database.register(AuditModel, {})
database.register(DepartamentModel, {})
database.register(ScoreformModel, {})
database.register(VideoformModel, {})
database.register(QuestionformModel, {})
database.register(ApprovalruleModel, {})
database.register(ConsumptionModel, {})
database.register(SourceModel, {})
database.register(CareerpageModel, {})
database.register(CareersiteModel, {})
database.register(MemberModel, {})
database.register(MemberInviteModel, {})
database.register(DisqualifyReasonModel, {})
database.register(CancelReasonModel, {})
database.register(ContractModel, {})
database.register(EventModel, {})
database.register(NoteModel, {})
database.register(MeetinsightModel, {})
database.register(GdprlogModel, {})
database.register(ShareCandidateModel, {})
database.register(QuestionnaireInviteModel, {})
database.register(QuestionnaireModel, {})
database.register(IntervideoInviteModel, {})
database.register(IntervideoModel, {})
database.register(IntervideoRatingModel, {})
database.register(IntervoiceInviteModel, {})
database.register(IntervoiceModel, {})
database.register(JobBoardModel, {})
database.register(PostingModel, {})
database.register(EmailModel, {})
database.register(EvaluationModel, {})
database.register(TaskModel, {})
database.register(ApprovalflowModel, {})
database.register(RequisitionModel, {})
database.register(ApprovalModel, {})
database.register(DashboardModel, {})
database.register(DashcomponentModel, {})
database.register(ConnectionModel, {})
database.register(ConversationModel, {})
database.register(MessageModel, {})

export default new Vuex.Store({
  modules: {
    auth: Auth,
    socket: Socket,
    alertModal: AlertModal,
    notification: Notification,
    me: Me,
    profile: Profile,
    calendarEvent: CalendarEvent,
    account: Account,
    accountSettings: AccountSettings,
    accountDomains: AccountDomains,
    accountSSO: AccountSSO,
    accountCareersite: AccountCareersite,
    accountApplyfields: AccountApplyfields,
    accountSocial: AccountSocial,
    accountConversationalAgent: AccountConversationalAgent,
    accountResourceAvailability: AccountResourceAvailability,
    integrations: Integrations,
    connections: Connections,
    messagingChannels: MessagingChannels,
    messagingConversations: MessagingConversations,
    messagingMessages: MessagingMessages,
    job: Job,
    jobLog: JobLog,
    jobJobScoreform: JobScoreform,
    jobAttach: JobAttach,
    candidate: Candidate,
    candidateBoard: CandidateBoard,
    candidateController: CandidateController,
    candidateSelected: CandidateSelected,
    candidateAttach: CandidateAttach,
    resource: Resource,
    placement: Placement,
    tag: Tag,
    customField: CustomFieldGroup,
    role: Role,
    session: Session,
    templatemail: Templatemail,
    templateapply: Templateapply,
    stage: Stage,
    dexport: Dexport,
    dataimex: Dataimex,
    disqualifyReason: DisqualifyReason,
    activity: Activity,
    company: Company,
    audit: Audit,
    departament: Departament,
    scoreform: Scoreform,
    videoform: Videoform,
    questionform: Questionform,
    approvalrule: Approvalrule,
    consumption: Consumption,
    source: Source,
    careerpage: Careerpage,
    careersite: Careersite,
    member: Member,
    memberInvite: MemberInvite,
    cancelReason: CancelReason,
    contract: Contract,
    media: Media,
    event: Event,
    note: Note,
    meetinsight: Meetinsight,
    meetcontext: Meetcontext,
    gdprlog: Gdprlog,
    shareCandidate: ShareCandidate,
    questionnaireInvite: QuestionnaireInvite,
    questionnaire: Questionnaire,
    intervideoInvite: IntervideoInvite,
    intervideo: Intervideo,
    intervideoRating: IntervideoRating,
    intervoiceInvite: IntervoiceInvite,
    intervoice: Intervoice,
    candidateDuplicates: CandidateDuplicates,
    JobBoard: JobBoard,
    Posting: Posting,
    Email: Email,
    Evaluation: Evaluation,
    Task: Task,
    Approvalflow: Approvalflow,
    Requisition: Requisition,
    Approval: Approval,
    Dashboard: Dashboard,
    Dashcomponent: Dashcomponent,
    Warn: Warn,
    MeetMain: MeetMain,
    Modalo: Modalo,
    ReportingFilters: ReportingFilters,
    Billing: Billing,
    CreateBilling: CreateBilling,
    Menu: Menu
  },
  plugins: [
    VuexORM.install(database)
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js